module.exports = __webpack_public_path__ + "static/media/vitrine-chanel.89e46bcb.jpg";